import {useEffect, useState} from "react";
import {useForm} from "@inertiajs/react";
import {ComponentConfig, FieldLabel} from "@measured/puck";
import FileUploader from "@/Components/System/FileUploader/FileUploader";
import {Icon} from "@iconify/react";

// @ts-ignore
const ImageField: ComponentConfig = {
    fields: {
         image: {
            type: "custom",
            label: "Obraz",
            render: ({ field, name, onChange, value }) => {
                const [selectedImage, setSelectedImage] = useState(value);
                const [droppable, setDroppable] = useState<boolean>(false);

                const { data, setData, errors } = useForm<{
                    [name: string]: string;
                }>({
                    [name]: value != undefined ? value : '',
                })

                useEffect(() => {
                    if(data[name] != '' && data[name] != undefined){
                        // @ts-ignore
                        onChange(data[name])
                    }
                }, [data[name]])


                return (
                    <FieldLabel label={field.label || name} icon={<Icon icon={'material-symbols:image'} width={16} height={16}/>}>
                        <FileUploader
                            data={data}
                            setData={setData}
                            fileKey='image'
                            disk='articles'
                            errors={{}}
                            icon='gg:loadbar-doc'
                            label='Dodaj obraz'
                            acceptedFormats='.jpg,.jpeg,.png,.gif,.bmp,.tiff,.heif,.heic,.avif,.svg'
                        />
                    </FieldLabel>
                );
            },
        },
    },
};

export default ImageField;
